"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterateValues = void 0;
const lodash_1 = __importDefault(require("lodash"));
//Functions to handle item iteration - currently should only be called from async, but both async and sync can use the same functions if needed later on.
const handleObject = (obj, oldNodeId, addition, originalNodeId, path, nodeMap, localMapDefinition, og, cachedResolver) => {
    Object.keys(obj).forEach(i => {
        //For each key of the object in question
        const inp = obj[i];
        if (inp && inp.sourceObject && inp.sourcePath) {
            //If this value has sourceObject and sourcePath, it is referencing an input value
            if (inp.sourceObject === oldNodeId) {
                //Check source object to see if it is referencing our oldNodeId
                localMapDefinition.nodes[originalNodeId + addition] = //If so, create a new node if relevant
                    localMapDefinition.nodes[originalNodeId + addition] || lodash_1.default.cloneDeep(localMapDefinition.nodes[originalNodeId]); //If it already exists, keep it. Otherwise do a deep clone of the original - this is to prevent changes made to the clone from affecting the original
                const newInp = lodash_1.default.get(localMapDefinition.nodes[originalNodeId + addition], path + '.' + i); //Get the input object that we want to change
                newInp.sourceObject = oldNodeId + addition; //Update source object to the new node value
                nodeMap[originalNodeId + addition] = cachedResolver; //Set nodemap for the new node
                addNewNode(originalNodeId, addition, nodeMap, localMapDefinition, og, cachedResolver); //Update all nodes downstream of the updated node
            }
        }
        else if (typeof inp === 'object' && inp !== null) {
            //If the value is an object, but not an input reference, recursively call this to handle any inputs within the object
            handleObject(inp, oldNodeId, addition, originalNodeId, path + '.' + i, nodeMap, localMapDefinition, og, cachedResolver);
        }
    });
};
const addNewNode = (oldNodeId, addition, nodeMap, localMapDefinition, ogMapDefinition, cachedResolver) => {
    Object.keys(ogMapDefinition.nodes).forEach(originalNodeId => {
        if (localMapDefinition.nodes[originalNodeId].inputs) {
            //For each node that has inputs, check each input value for the oldNodeId and make copies if it is found
            handleObject(localMapDefinition.nodes[originalNodeId].inputs, oldNodeId, addition, originalNodeId, 'inputs', nodeMap, localMapDefinition, ogMapDefinition, cachedResolver);
        }
    });
};
const iterateValues = (arr, nodeId, addToCache, nodeMap, localMapDefinition, cachedResolver) => {
    const og = lodash_1.default.cloneDeep(localMapDefinition);
    arr.forEach((item, index) => {
        //For each value...
        if (index > 0) {
            //Other than the first one...
            nodeMap[`${nodeId}-iteration-${nodeId}-${index}`] = cachedResolver; //Add to nodemap
            addToCache(`${nodeId}-iteration-${nodeId}-${index}`, item); //Assign value to cache so it can be resolved correctly later...
            addNewNode(nodeId, `-iteration-${nodeId}-${index}`, nodeMap, localMapDefinition, og, cachedResolver); //And add copies of all nodes downstream of the affected node
        }
    });
    return arr[0]; //Return first item so it can be used as the value for non-duplicated nodes.
};
exports.iterateValues = iterateValues;
//# sourceMappingURL=MapExecutor.js.map